import * as types from './mutation-types';
import { getStore, setStore } from '@lib/util';

const mutations = {
  [types.SEAL_TYPE](state, sealType) {
    state.sealType = sealType;
  },
  [types.SEAL_COLOR](state, sealColor) {
    state.sealColor = sealColor;
  },
  [types.SEAL_SHOW_URI](state, sealShowUrl) {
    state.sealShowUrl = sealShowUrl;
  },
  [types.PER_ADD_TYPE](state, perAddType) {
    state.perAddType = perAddType;
  },
  [types.INFO_SET_STORE](state, {key, userInfo}) {
    if (state.infoDateStore === '') {
      state.infoDateStore = getStore(key ? key : 'userInfo');
    } else {
      state.infoDateStore = userInfo;
      setStore(key ? key : 'userInfo', userInfo);
    }
  },
  // 模板搜索内容
  [types.TEMPLATE_SEARCH_CONTENT](state, templateSearchContent) {
    state.templateSearchContent = templateSearchContent;
  },
  // 模板当前页面
  [types.TEMPLATE_CURRENT_PAGE](state, templateCurrentPage) {
    state.templateCurrentPage = templateCurrentPage;
  },
  // 批量签署
  [types.BATCH_LIST](state, list) {
    state.batchList = list;
  },
  // 其他页面 文件上传 数据存储
  [types.FILES_UPLOAD_OTHER](state, event) {
    state.filesUploadOther = event;
  }
};
export default mutations;




// WEBPACK FOOTER //
// ./src/pages/admin/store/mutations.js